<template>
  <l-modal :showing="showing" text="Samples" icon="edit" color="bg-orange-500" @close="close">
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/3 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-2/3">
          <b>Inlet Height</b>
          <br />
          <l-input
            placeholder="Enter 'Inlet Height' (whole number)"
            v-model="editObj.inlet_height"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="w-full flex mb-4">
        <div class="w-1/3 mr-2">
          <b>Building Distance</b>
          <br />
          <l-input
            placeholder="Enter 'Building Distance' (optional) (whole number)"
            v-model="editObj.building_distance"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-2/3">
          <b>Kerb Distance</b>
          <br />
          <l-input
            placeholder="Enter 'Kerb Distance' (optional) (whole number)"
            v-model="editObj.kerb_distance"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>

      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";

export default {
  name: "LLEdit",
  props: ["showing", "samples", "selected", "isnew"],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
  computed: {
    editObj: function() {
      // debugger;
      return Object.assign({}, this.selected);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSave() {
      // debugger;

      this.$emit("save", this.editObj);
      this.close();
    }
  }
};
</script>